import React from 'react';
import { Search, Bell } from 'lucide-react';
export function TopBar() {
  return <div className="md:hidden flex items-center justify-between h-[64px] px-4 bg-growthly-surface border-b border-white/5 sticky top-0 z-20" data-id="element-263">
      <img src="https://cdn.magicpatterns.com/uploads/dr1thyRsJErG9ttdFTQtof/Captura_de_pantalla_2026-04-28_a_las_19.45.31-removebg-preview.png" alt="Growthly Logo" className="h-6 object-contain invert" data-id="element-264" />
      <div className="flex items-center space-x-4 text-growthly-muted" data-id="element-265">
        <Search className="w-5 h-5" data-id="element-266" />
        <Bell className="w-5 h-5" data-id="element-267" />
      </div>
    </div>;
}